import React, { useEffect, useRef } from "react"; // Import useRef

// The timer threshold, in seconds.
const HIDE_THRESHOLD_SECONDS = 7;

function TimerFullScreen({ hideControlBarAction, isPlaying, isShowing, setCounter, initialValue }) {

    // Use a ref to hold the timeout ID so it can be cleared across renders.
    const timeoutRef = useRef(null);

    // This effect manages the inactivity timer.
    // It runs whenever isPlaying or isShowing changes.
    useEffect(() => {
        // Clear any existing timer to prevent multiple timers and ensure reset.
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Only set a new timer if content is playing and the control bar is visible.
        if (isPlaying && isShowing) {
            // Set a timeout to hide the control bar after the threshold.
            timeoutRef.current = setTimeout(() => {
                console.log("Inactivity detected, hiding control bar."); // For debugging
                hideControlBarAction();
                setCounter()
                initialValue(); // Reset any internal counter/state related to this timer.
            }, HIDE_THRESHOLD_SECONDS * 1000); // Convert seconds to milliseconds

            // No need to update `counter` state within this component's logic
            // unless you explicitly want to display the countdown.
            // If `setCounter` is meant for an external counter, you'd call it elsewhere.
            // For hiding, the primary mechanism is the timeout.

        } else {
            // If not playing or not showing, ensure the timer is cleared.
            console.log("Timer conditions not met (not playing or not showing), clearing timer."); // For debugging
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null; // Clear the ref
        }

        // Cleanup function: This runs when the component unmounts OR
        // when the dependencies (isPlaying, isShowing) change before the effect re-runs.
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [isPlaying, isShowing, hideControlBarAction, initialValue,setCounter]);
    // Dependencies:
    // - isPlaying, isShowing: To react to changes in playback or visibility.
    // - hideControlBarAction, initialValue: Stable references (functions) from props.
    //   React ensures function props are stable if they don't change, but it's good practice
    //   to include them if they are used inside the effect.

    // If you need to expose a mechanism to reset the timer from outside (e.g., on mouse move):
    // const resetTimer = useCallback(() => {
    //     // This will trigger the useEffect by changing `isShowing` or a similar prop,
    //     // or you could make this a direct prop.
    //     // For example, if hideControlBarAction also makes the control bar show,
    //     // that would naturally restart the timer.
    // }, []);

    // The component renders nothing visible itself.
    return (
        <></>
    );
}

export default TimerFullScreen;